// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import RepublicOfTheCongo from '../_raw/flag/icon_flag_republic_of_the_congo.png';

export default () => <img src={RepublicOfTheCongo} alt="RepublicOfTheCongo" />;
